import React, { useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);

import Scrollspy from 'react-scrollspy';
import WindowBrowser from "../components/browser-window";


const Parts = () => {
  const headers = ['Parts'];
  
  useEffect(() => {
    
  
  }, [])
  
  return (
    <div className="simple_page">
      <div className="mainIntro">
        <h1>Parts </h1>
        <h3>Spot the fake. Safeguard the cure.</h3>
      </div>
      <section className="divider">
        <div className="fixed_sidebar">
          <div className="sidebar">
            <div className="main_sidebar">
              25 Modeled Parts 
            </div>
            {/* <Scrollspy
              offset={-140}
              className="scrollspy" items={
                headers.map(header => {
                  return header.split(' ')[0]
                })
              }
              currentClassName="active">
              {
                headers.map(header=>{
                   
                  return (
                    <li><a href={"#"+header.split(' ')[0]}>{
                      header.replace('_', '')
                    }</a></li>
                  )
                  
                })
              }
            </Scrollspy> */}
            
            <img
              style={{paddingTop: '30px'}}
              src="https://static.igem.wiki/teams/5334/wiki-images/mascot/mascot-holding-placard-1.png"
              alt="Mascot with placard iGEM2024"
    
            />

          </div>

        </div>
        <div className="main_lab_style">
        <WindowBrowser header="Parts" description={
            <>
              <div style={{ display: 'none' }}>
                {
                  headers.map(header => {
                    return (
                      <section href={header.split(' ')[0]}>{
                        header
                      }</section>
                    )

                  })
                }
              </div>

              <div>
                <div>
                  <section id="Parts">

                  <table>
                      <tbody>
                        <tr>
                          <td>
                            <p>Part name</p>
                          </td>
                          <td>
                            <p>Description</p>
                          </td>
                          <td>
                            <p>Length</p>
                          </td>

                        </tr>
                        <tr>
                          <td>
                            <p><a target="_blank" href="https://parts.igem.org/Part:BBa_K5334000">BBa_K5334000</a></p>
                          </td>
                          <td>
                            <p> A14#1 aptamer for Bevacizumab. </p>
                          </td>
                          <td>
                            <p>24</p>
                          </td>                      
                        </tr>
                      </tbody>
                    </table>
                    <p>This aptamer was obtained by Saito <i>et al.</i> using the SELEX method, after which we utilized it for further modeling and optimization. Utilizing the structural ideogram of the previously characterized aptamer, we aimed to engineer interactions involving residues that were not previously engaged in antibody binding: T5, T6, G7, G8, T9, G10, G11, T12, A13, G14, T15, T16, A17, C18, G19, T20, T21. By focusing on these non-binding residues, we sought to enhance both the stability and specificity of the aptamer. A14#1 aptamer was subsequently used as a control in various assays, including lateral flow assays (LFA), microscale thermophoresis (MST), and enzyme-linked oligonucleotide assay (ELONA), to compare its performance and binding efficacy to optimized CU2#19 aptamer.
                    </p>
                    <br></br>

                    <table>
                      <tbody>
                        <tr>
                          <td>
                            <p><a target="_blank" href="http://parts.igem.org/Part:BBa_K5334019">BBa_K5334019</a></p>
                          </td>
                          <td>
                            <p>CU2#19 aptamer for Bevacizumab.</p>
                          </td>
                          <td>
                            <p>24</p>
                          </td>                         
                        </tr>
                      </tbody>
                      
                    </table>
                    <p>The molecular dynamics results indicated that the initial aptamer A14#1 exhibits a lower affinity for bevacizumab compared to aptamer CU2#19 with p&lt;0.01. Results showed that aptamer CU2#19 formed hydrogen bonds with T28, N31, G33, N35, N52, H101, and Y103 of bevacizumab. Consequently,CU2#19 was used for wet-lab experiments and the development of the LFA device.</p>

                    <br>
                    </br>

                    <h2>We also modeled:</h2>
                    <table>
                      <tbody>
                        <tr>
                          <td>
                            <p>Part name</p>
                          </td>
                          <td>
                            <p>Description</p>
                          </td>
                          <td>
                            <p>Length</p>
                          </td>

                        </tr>
                        <tr>
                          <td>
                            <p><a target="_blank" href="https://parts.igem.org/Part:BBa_K5334001">BBa_K5334001</a></p>
                          </td>
                          <td>
                            <p>CU2#1 aptamer for Bevacizumab</p>
                          </td>
                          <td>
                            <p>24</p>
                          </td>                      
                        </tr>
                        <tr>
                          <td>
                            <p><a target="_blank" href="http://parts.igem.org/Part:BBa_K5334002">BBa_K5334002</a></p>
                          </td>
                          <td>
                            <p>CU2#2 aptamer for Bevacizumab</p>
                          </td>
                          <td>
                            <p>24</p>
                          </td>                         
                        </tr>
                        <tr>
                          <td>
                            <p><a target="_blank" href="http://parts.igem.org/Part:BBa_K5334003">BBa_K5334003</a></p>
                          </td>
                          <td>
                            <p>CU2#3 aptamer for Bevacizumab</p>
                          </td>
                          <td>
                            <p>24</p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p><a target="_blank" href="http://parts.igem.org/Part:BBa_K5334004">BBa_K5334004</a></p>
                          </td>
                          <td>
                            <p>CU2#4 aptamer for Bevacizumab</p>
                          </td>
                          <td>
                            <p>24</p>
                          </td>                          
                        </tr>
                        <tr>
                          <td>
                            <p><a target="_blank" href="http://parts.igem.org/Part:BBa_K5334005">BBa_K5334005</a></p>
                          </td>
                          <td>
                            <p>CU2#5 aptamer for Bevacizumab</p>
                          </td>
                          <td>
                            <p>24</p>
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <p><a target="_blank" href="http://parts.igem.org/Part:BBa_K5334006">BBa_K5334006</a></p>
                          </td>
                          <td>
                            <p>CU2#6 aptamer for Bevacizumab</p>
                          </td>
                          <td>
                            <p>24</p>
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <p><a target="_blank" href="https://parts.igem.org/Part:BBa_K5334007">BBa_K5334007</a></p>
                          </td>
                          <td>
                            <p>CU2#7 aptamer for Bevacizumab</p>
                          </td>
                          <td>
                            <p>24</p>
                          </td>                      
                        </tr>
                        <tr>
                          <td>
                            <p><a target="_blank" href="http://parts.igem.org/Part:BBa_K5334008">BBa_K5334008</a></p>
                          </td>
                          <td>
                            <p>CU2#8 aptamer for Bevacizumab</p>
                          </td>
                          <td>
                            <p>24</p>
                          </td>                         
                        </tr>
                        <tr>
                          <td>
                            <p><a target="_blank" href="http://parts.igem.org/Part:BBa_K5334009">BBa_K5334009</a></p>
                          </td>
                          <td>
                            <p>CU2#9 aptamer for Bevacizumab</p>
                          </td>
                          <td>
                            <p>24</p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p><a target="_blank" href="http://parts.igem.org/Part:BBa_K5334010">BBa_K5334010</a></p>
                          </td>
                          <td>
                            <p>CU2#10 aptamer for Bevacizumab</p>
                          </td>
                          <td>
                            <p>24</p>
                          </td>                          
                        </tr>
                        <tr>
                          <td>
                            <p><a target="_blank" href="http://parts.igem.org/Part:BBa_K5334011">BBa_K5334011</a></p>
                          </td>
                          <td>
                            <p>CU2#11 aptamer for Bevacizumab</p>
                          </td>
                          <td>
                            <p>24</p>
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <p><a target="_blank" href="http://parts.igem.org/Part:BBa_K5334012">BBa_K5334012</a></p>
                          </td>
                          <td>
                            <p>CU2#12 aptamer for Bevacizumab</p>
                          </td>
                          <td>
                            <p>24</p>
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <p><a target="_blank" href="https://parts.igem.org/Part:BBa_K5334013">BBa_K5334013</a></p>
                          </td>
                          <td>
                            <p>CU2#13 aptamer for Bevacizumab</p>
                          </td>
                          <td>
                            <p>24</p>
                          </td>                      
                        </tr>
                        <tr>
                          <td>
                            <p><a target="_blank" href="http://parts.igem.org/Part:BBa_K5334014">BBa_K5334014</a></p>
                          </td>
                          <td>
                            <p>CU2#14 aptamer for Bevacizumab</p>
                          </td>
                          <td>
                            <p>24</p>
                          </td>                         
                        </tr>
                        <tr>
                          <td>
                            <p><a target="_blank" href="http://parts.igem.org/Part:BBa_K5334015">BBa_K5334015</a></p>
                          </td>
                          <td>
                            <p>CU2#15 aptamer for Bevacizumab</p>
                          </td>
                          <td>
                            <p>24</p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p><a target="_blank" href="http://parts.igem.org/Part:BBa_K5334016">BBa_K5334016</a></p>
                          </td>
                          <td>
                            <p>CU2#16 aptamer for Bevacizumab</p>
                          </td>
                          <td>
                            <p>24</p>
                          </td>                          
                        </tr>
                        <tr>
                          <td>
                            <p><a target="_blank" href="http://parts.igem.org/Part:BBa_K5334017">BBa_K5334017</a></p>
                          </td>
                          <td>
                            <p>CU2#17 aptamer for Bevacizumab</p>
                          </td>
                          <td>
                            <p>24</p>
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <p><a target="_blank" href="http://parts.igem.org/Part:BBa_K5334018">BBa_K5334018</a></p>
                          </td>
                          <td>
                            <p>CU2#18 aptamer for Bevacizumab</p>
                          </td>
                          <td>
                            <p>24</p>
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <p><a target="_blank" href="https://parts.igem.org/Part:BBa_K5334020">BBa_K5334020</a></p>
                          </td>
                          <td>
                            <p>CU2#20 aptamer for Bevacizumab</p>
                          </td>
                          <td>
                            <p>24</p>
                          </td>                      
                        </tr>
                        <tr>
                          <td>
                            <p><a target="_blank" href="http://parts.igem.org/Part:BBa_K5334021">BBa_K5334021</a></p>
                          </td>
                          <td>
                            <p>CU2#21 aptamer for Bevacizumab</p>
                          </td>
                          <td>
                            <p>24</p>
                          </td>                         
                        </tr>
                        <tr>
                          <td>
                            <p><a target="_blank" href="http://parts.igem.org/Part:BBa_K5334022">BBa_K5334022</a></p>
                          </td>
                          <td>
                            <p>CU2#22 aptamer for Bevacizumab</p>
                          </td>
                          <td>
                            <p>24</p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p><a target="_blank" href="http://parts.igem.org/Part:BBa_K5334023">BBa_K5334023</a></p>
                          </td>
                          <td>
                            <p>CU2#23 aptamer for Bevacizumab</p>
                          </td>
                          <td>
                            <p>24</p>
                          </td>                          
                        </tr>
                        <tr>
                          <td>
                            <p><a target="_blank" href="http://parts.igem.org/Part:BBa_K5334024">BBa_K5334024</a></p>
                          </td>
                          <td>
                            <p>CU2#24 aptamer for Bevacizumab</p>
                          </td>
                          <td>
                            <p>24</p>
                          </td>
                        </tr>

                      </tbody>
                    </table>
                  </section>
                </div>

              </div>
            </>
          } />
        </div>
      </section>
    </div>
  );
}

export default Parts;
